<template>
  <div style="height:100%">
    <span>区域：</span>
    <Select v-model="searchArea" style="width:150px;margin-right:20px" clearable>
      <Option v-for="depart in areaArr" :key="depart.id" :value="depart['name']">{{depart['name']}}</Option>
    </Select>
    <span>标准名称:</span>
    <Input style="width:150px;margin:5px 10px;" type="text" v-model="searchName"/>
    <span>更新日期：</span>
    <DatePicker type="date" style="width: 120px" v-model="startTime"></DatePicker>
    <span> 至 </span>
    <DatePicker type="date" style="width: 120px" v-model="endTime"></DatePicker>
    <Button type="primary" @click="getList" style="margin:0 10px">搜索</Button>
    <Button type="primary" @click="expertFeeStandard={};showModal=true;modalType='新增'">新增标准</Button>
    <Table :columns="columns" :data="tableData" style="min-width:1000px;margin:10px 0"></Table>
    <Page :total="pageTotal" :current="pageNum" :page-size="10" show-elevator show-total @on-change="pageChange"></Page>
    <!-- 新增弹窗 -->
    <Modal v-model="showModal" :title="modalType+'专家费标准'">
      <Form ref="form" :model="expertFeeStandard" :rules="ruleValidate" :label-width="80" style="padding:0 10px">
        <FormItem label="标准名称" prop="standardName">
          <Input v-model="expertFeeStandard.standardName"></Input>
        </FormItem>
        <Row>
          <Col span="11">
            <FormItem label="适用区域" prop="district">
              <Select v-model="expertFeeStandard.district" @on-open-change="filterArea">
                <Option v-for="depart in areaArr" :key="depart.id" :value="depart['name']" :disabled="existArea.indexOf(depart['name'])!==-1">
                  {{depart['name']}}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12" offset="1">
            <FormItem label="评审基本时长" prop="reviewTime" :label-width="100">
              <Input v-model="expertFeeStandard.reviewTime" number><span slot="append">时</span></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11" style="display:flex;position:relative">
            <Tooltip placement="top" style="position:absolute;left:-10px">
              <Icon type="ios-help-outline" size="18" style="line-height:32px"></Icon>
              <div slot="content">
                <p>评审不超过基本时</p>
                <p>长则支付基本费用</p>
              </div>
            </Tooltip>
            <FormItem label="本地专家" prop="localExpert">
              <Input v-model="expertFeeStandard.localExpert" number><span slot="append">元/人</span></Input>
            </FormItem>
          </Col>
          <Col span="11" offset="2" style="display:flex;position:relative">
            <Tooltip placement="top" style="position:absolute;left:-10px">
              <Icon type="ios-help-outline" size="18" style="line-height:32px"></Icon>
              <div slot="content">
                <p>评审超过基本时长后，每</p>
                <p>增加1小时评审时间，按照</p>
                <p>时薪增加对应的费用。</p>
              </div>
            </Tooltip>
            <FormItem label="最低时薪" prop="localMininumWage">
              <Input v-model="expertFeeStandard.localMininumWage" number><span slot="append">元</span></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11" style="display:flex;position:relative">
            <Tooltip placement="top" style="position:absolute;left:-10px">
              <Icon type="ios-help-outline" size="18" style="line-height:32px"></Icon>
              <div slot="content">
                <p>评审不超过基本时</p>
                <p>长则支付基本费用</p>
              </div>
            </Tooltip>
            <FormItem label="外地专家" prop="outsideExpert">
              <Input v-model="expertFeeStandard.outsideExpert" number><span slot="append">元/人</span></Input>
            </FormItem>
          </Col>
          <Col span="11" offset="2" style="display:flex;position:relative">
            <Tooltip placement="top" style="position:absolute;left:-10px">
              <Icon type="ios-help-outline" size="18" style="line-height:32px"></Icon>
              <div slot="content">
                <p>评审超过基本时长后，每</p>
                <p>增加1小时评审时间，按照</p>
                <p>时薪增加对应的费用。</p>
              </div>
            </Tooltip>
            <FormItem label="最低时薪" prop="outsideMininumWage">
              <Input v-model="expertFeeStandard.outsideMininumWage" number><span slot="append">元</span></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <FormItem label="监督" prop="supervisor">
              <Input v-model="expertFeeStandard.supervisor" number><span slot="append">元/人</span></Input>
            </FormItem>
          </Col>
          <Col span="11" offset="2" style="display:flex;position:relative">
            <Tooltip placement="top" style="position:absolute;left:-10px">
              <Icon type="ios-help-outline" size="18" style="line-height:32px"></Icon>
              <div slot="content">
                <p>评审超过基本时长后，每</p>
                <p>增加1小时评审时间，按照</p>
                <p>时薪增加对应的费用。</p>
              </div>
            </Tooltip>
            <FormItem label="最低时薪" prop="supervisorMininumWage">
              <Input v-model="expertFeeStandard.supervisorMininumWage" number><span slot="append">元</span></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <FormItem label="采购人" prop="purchaser">
              <Input v-model="expertFeeStandard.purchaser" number><span slot="append">元/人</span></Input>
            </FormItem>
          </Col>
          <Col span="11" offset="2" style="display:flex;position:relative">
            <Tooltip placement="top" style="position:absolute;left:-10px">
              <Icon type="ios-help-outline" size="18" style="line-height:32px"></Icon>
              <div slot="content">
                <p>评审超过基本时长后，每</p>
                <p>增加1小时评审时间，按照</p>
                <p>时薪增加对应的费用。</p>
              </div>
            </Tooltip>
            <FormItem label="最低时薪" prop="purchaserMininumWage">
              <Input v-model="expertFeeStandard.purchaserMininumWage" number><span slot="append">元</span></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <FormItem label="交通费" prop="trafficExpense">
              <Input v-model="expertFeeStandard.trafficExpense" number><span slot="append">元/人</span></Input>
            </FormItem>
          </Col>
        </Row>
        <!-- <FormItem style="margin:0;text-align:center">
          <Button type="ghost" @click="showModal=false" style="margin-left: 8px">取消</Button>
          <Button type="primary" style="margin-left:20px" @click="createStandard">确定</Button>
        </FormItem> -->
      </Form>
      <div slot="footer">
        <Button type="ghost" @click="showModal=false" style="margin-left: 8px">取消</Button>
        <Button type="primary" style="margin-left:20px" @click="createStandard">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import requestUrls from '@/lib/requestUrls'
  import ajax from '@/lib/ajax'
  import { formatDate } from '@/lib/tool'

  export default {
    data() {
      return {
        columns: [
          {
            title: '区域',
            key: 'district',
            align: 'center',
            width: 100,
          }, 
          {
            title: '标准名称',
            key: 'standardName',
          }, 
          {
            title: '评审基本时长(小时)',
            key: 'reviewTime',
            align: 'center',
            width: 94,
          },
          {
            title: '本地专家(元/人)',
            key: 'localExpert',
            align: 'center',
            width: 100,
          },
          {
            title: '外地专家(元/人)',
            key: 'outsideExpert',
            align: 'center',
            width: 100,
          },
          {
            title: '监督专家(元/人)',
            key: 'supervisor',
            align: 'center',
            width: 100,
          },
          {
            title: '采购人(元/人)',
            key: 'purchaser',
            align: 'center',
            width: 90,
          },
          {
            title: '交通费(元/人)',
            key: 'trafficExpense',
            align: 'center',
            width: 90,
          },
          {
            title: '创建者',
            key: 'creator',
            align: 'center',
            width: 100
          },
          {
            title: '更新日期',
            align: 'center',
            width: 150,
            render: (h, params) => {
              return h('div', formatDate(params.row.lastModificationTime))
            }
          },
          {
            title: '操作',
            key: '座机号码',
            width: 135,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.modalType = '编辑'
                      this.expertFeeStandard = Object.assign({}, params.row)
                      this.showModal = true
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.deleteStandard(params.row)
                    }
                  }
                }, '删除')
              ]);
            }
          }
        ],
        pageNum: 1,
        pageTotal: 0,
        tableData: [],
        searchName:'',//查询框的值
        areaArr: [],
        searchArea: '',
        searchName: '',
        startTime: '',
        endTime: '',
        showModal: false,
        modalType: '新增',
        expertFeeStandard: {
          "standardName": "",
          "district": "",
          "reviewTime": "",
          "localExpert": "",
          "localMininumWage": "",
          "outsideExpert": "",
          "outsideMininumWage": "",
          "supervisor": "",
          "supervisorMininumWage": "",
          "purchaser": "",
          "purchaserMininumWage": "",
          "trafficExpense": ""
        },
        ruleValidate: {
          standardName: [
            { required: true, message: '标准名称不能为空', trigger: 'blur' }
          ],
          district: [
            { required: true, message: '适用区域不能为空', trigger: 'blur' }
          ],
          reviewTime: [
            { type: 'number', required: true, message: '评审基本时长不能为空', trigger: 'blur' }
          ],
          localExpert: [
            { type: 'number', required: true, message: '本地专家不能为空', trigger: 'blur' }
          ],
          localMininumWage: [
            { type: 'number', required: true, message: '最低时薪不能为空', trigger: 'blur' }
          ],
          outsideExpert: [
            { type: 'number', required: true, message: '外地专家不能为空', trigger: 'blur' }
          ],
          outsideMininumWage: [
            { type: 'number', required: true, message: '最低时薪不能为空', trigger: 'blur' }
          ],
          supervisor: [
            { type: 'number', required: true, message: '监督不能为空', trigger: 'blur' }
          ],
          supervisorMininumWage: [
            { type: 'number', required: true, message: '最低时薪不能为空', trigger: 'blur' }
          ],
          purchaser: [
            { type: 'number', required: true, message: '采购人不能为空', trigger: 'blur' }
          ],
          purchaserMininumWage: [
            { type: 'number', required: true, message: '最低时薪不能为空', trigger: 'blur' }
          ],
          trafficExpense: [
            { type: 'number', required: true, message: '交通费不能为空', trigger: 'blur' }
          ],
        },
        existArea: []
      }
    },
    async created() {
      // 获取分公司信息
      let areaRep = await ajax.get(requestUrls.CLDistrict.GetList)
      if (areaRep.data.success && areaRep.data.result.items.length > 0) {
        this.areaArr = areaRep.data.result.items
      }
      this.getList()
    },
    methods: {
      getList () {
        const searchArea = this.searchArea ? ` and district.Contains("${this.searchArea}")` : ''
        const searchName = this.searchName ? ` and standardName.Contains("${this.searchName}")` : ''
        const startTime = this.startTime ? ` and lastModificationTime > "${formatDate(this.startTime)}"` : ''
        const endTime = this.endTime ? ` and lastModificationTime < "${formatDate(this.endTime)}"` : ''
        const filter = searchArea + searchName + startTime + endTime.replace('00:00:00', '23:59:59')
        // 获取列表数据
        ajax.get(requestUrls.ExpertFeeStandard.GetPaged, {
          params: {
            filter: filter.slice(4),
            sorting: 'creationTime desc',
            maxResultCount: 10,
            skipCount: ( this.pageNum - 1 ) * 10
          }
        }).then(res => {
          this.tableData = res.data.result.items
          this.pageTotal = res.data.result.totalCount
        })
      },
      createStandard () {
        this.$refs.form.validate(async(valid) => {
          if (valid) {
            this.$Spin.show()
            let rep = await ajax.post(requestUrls.ExpertFeeStandard.CreateOrUpdate, {
              expertFeeStandard: Object.assign(this.expertFeeStandard, {
                creator: this.$store.state.session.user.name
              })
            })
            if (rep.data.success) {
              this.$Spin.hide()
              this.$Message.success('新增成功！')
              this.showModal = false
              this.getList()
            }
          }
        })
      },
      pageChange(pageNum) {
        this.pageNum = pageNum
        this.getList()
      },
      deleteStandard (item) {
        this.$Modal.confirm({
          title: '删除提示',
          content: `确定删除专家费标准（${item.standardName}）吗？`,
          onOk: () => {
            this.$Spin.show()
            ajax.delete(requestUrls.ExpertFeeStandard.Delete,{
              params: {
                id: item.id
              }
            }).then(res => {
              if (res.data.success) {
                this.$Spin.hide()
                this.$Message.success('已删除')
                this.getList()
              }
            })
          }
        })
      },
      async filterArea (e) {
        if (e) {
          let rep = await ajax.get(requestUrls.ExpertFeeStandard.GetPaged, {
            params: {
              maxResultCount: 100
            }
          })
          this.existArea = rep.data.result.items.map(item => {
            return item.district
          })
        }
      }
    },
  }
</script>